import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { Modal } from '@els/els-react--modal';
import { Icon } from '@els/els-react--icon';
import { LEGACY_DIALOG_SIZE } from '@Containers/Dialogs/DialogsConstants';

import './DialogWithInfoLayout.scss';

export default function DialogWithNotificationInfoLayout(props) {
  const { children, selfClose, onYesClick, footerClassName, yesLabel = 'OK', header, content, className } = props;

  const clickHandler = () => {
    selfClose();
    if (onYesClick) {
      onYesClick();
    }
  };

  return (
    <Modal
      className={classnames(className, 'dialog-with-info-layout')}
      label={header || 'Information'}
      onClose={selfClose}
      shouldPreventClickOverlayToClose
      width={LEGACY_DIALOG_SIZE}>
      <div className="dialog-with-info-layout__content">
        {header && (
          <header className="dialog-with-info-layout-header">
            <Icon sprite="InformationSolidSquare" size="m" color="secondary" isDecorative />
            <h4 className="dialog-with-info-layout-header-title">{header}</h4>
          </header>
        )}
        <section className="dialog-with-info-layout-body">{children || content}</section>
        <footer className={classnames(footerClassName, 'dialog-with-info-layout-footer-wrapper')}>
          <ButtonWithIcon
            data-e2e="dialog-ok"
            type="primary"
            size="small"
            sprite="ChevronRight"
            iconRight
            onClick={clickHandler}
            className="e2e-dialog-ok">
            {yesLabel}
          </ButtonWithIcon>
        </footer>
      </div>
    </Modal>
  );
}

DialogWithNotificationInfoLayout.propTypes = {
  selfClose: PropTypes.func.isRequired,
  onYesClick: PropTypes.func,
  yesLabel: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  className: PropTypes.string,
  footerClassName: PropTypes.string,
  children: PropTypes.node,
};
